import { useId as e, useLayoutEffect as t } from "react";
//#region src/hooks/useAnchoredPopover.ts
var n = (e) => {
	if (e) return "current" in e ? e.current : e;
}, r = (e) => !!(e && "showPopover" in e && "hidePopover" in e), i = (e) => {
	r(e) && e.matches(":popover-open") && e.hidePopover();
}, a = (e, t) => {
	if (r(e)) {
		if (t) {
			e.matches(":popover-open") || e.showPopover();
			return;
		}
		i(e);
	}
}, o = (e, r, o = []) => {
	t(() => {
		let t = n(e);
		return a(t, r), () => {
			i(t);
		};
	}, [
		r,
		e,
		...o
	]);
}, s = (t) => `--${t}-${e().replace(/:/g, "")}`;
//#endregion
export { s as useAnchorName, o as usePopover };

//# sourceMappingURL=useAnchoredPopover.js.map